import React from 'react';
import block from 'bem-cn-lite';

const b = block('CustomWorkflow');

export default ({title, header, folders=['', '']}) => (
    <div className={b('header')}>
        <div className={b('header-left')}>
            <h3 className={b('title')}>{title}</h3>
            <div className={b('folders')}>
                {folders.map((folder, index) => <div key={index} className={b('folder-placeholder')}>{folder}</div>)}
            </div>
        </div>

        <div className={b('header-right')}>
            <img src="https://cdn.wrike.com/image/__cdnu/icon_grey_vector_collaboration_dots.svg" alt="..." className={b('header-dots')}/>
        </div>

    </div>
)